<script setup>
  import { computed, onMounted, ref } from 'vue'
  import { gsap } from 'gsap'
  import NumberAnimation from 'vue-number-animation'

  const props = defineProps({
    completed: String
  })

  const duration = 1.5
  const completedInt = ref(0)

  const completedNumber = computed(() => {
    return parseInt(props.completed) || 0
  })

  const format = (value) => {
    return value.toFixed(0)
  }

  onMounted(() => {
    gsap.to(completedInt, {
      value: completedNumber.value,
      duration,
      ease: 'power2.out'
    })
  })

  const totalIndicatorFill = computed(() => {
    return `conic-gradient(#C83528 0 ${completedInt.value}%, transparent ${completedInt.value}% 100%)`;
  })</script>

<template>
  <div
    class="study-fullfilment-indicator h-56 w-56 rounded-full flex items-center justify-center border-4 border-border"
  >
    <div
      class="study-fullfilment-indicator-fill h-56 w-56 rounded-full flex items-center justify-center"
      :style="{background: totalIndicatorFill}"
    >
      <div class="study-fullfillment-indicator-inner bg-white h-[90%] w-[90%] rounded-full">
        <div class="study-fullfillment-indicator-content h-full w-full flex flex-col items-center justify-center">
          <span
            class="~text-3xl/5xl mb-2"
          >
            <NumberAnimation
              :from="0"
              :to="completedNumber"
              :format="format"
              :duration="duration"
              autoplay
            />%
          </span>
          <span
            class="text-sm uppercase text-body"
          >
            Fortschritt
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>
